<template>
  <el-form>
    <el-form-item label="Email">
      <el-input v-model.trim="user.email" :disabled="true" />
    </el-form-item>
    <el-form-item label="Name">
      <el-input v-model.trim="user.name" />
    </el-form-item>
    <el-form-item label="Country">
      <el-select v-model="user.country"
        style="width:98%;"
      >
        <el-option
          v-for="item in countries"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="Time Zone">
      <el-select v-model="user.timezone"
        style="width:98%;"
      >
        <el-option
          v-for="(item, key) in timezones"
          :key="key"
          :label="item"
          :value="item"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="New Password" style="margin-bottom: 40px;" prop="password">
      <el-input
        :key="passwordType"
        ref="password"
        v-model="user.password"
        style="width:98%;"
        :type="passwordType"
        placeholder="Password"
        tabindex="2"
        autocomplete="on"
        @keyup.native="checkCapslock"
        @blur="capsTooltip = false"
      />
      <span class="show-pwd" @click="showPwd">
        <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
      </span>
    </el-form-item>
    <el-form-item label="Confrim Password" style="margin-bottom: 40px;" prop="confirmPassword">
      <el-input
        :key="passwordType"
        ref="confirmPassword"
        v-model="user.confirmPassword"
        style="width:98%;"
        :type="passwordType"
        placeholder="Confrim Password"
        tabindex="2"
        autocomplete="on"
        @keyup.native="checkCapslock"
        @blur="capsTooltip = false"
      />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submit">Update</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapActions } from 'vuex'
import UserResource from '@/api/user'
const userResource = new UserResource()
var moment = require('moment-timezone');

export default {
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          userId: 0,
          name: '',
          profile_pic_url: '',
          country: 0,
          timezone: '',
          email: '',
          password: '',
          confirmPassword: ''
        }
      }
    }
  },
  data: function() {
    return {
      countries: [],
      timezones: [],
      loading: false,
      passwordType: 'password',
      capsTooltip: false,
      errorCodeMessage: {
        0: { 'type': 'success', 'title': ' Success', 'message': ' Success' },
        1: { 'type': 'error', 'title': 'Something went wrong', 'message': 'Something went wrong, please try again.' },
        4: { 'type': 'warning', 'title': 'Warning', 'message': 'Please try again.' },
        5: { 'type': 'error', 'title': 'Nothing Changes', 'message': 'Nothing Changes' }
      }
    }
  },
  created() {
    this.getOptions();
    console.log("timezone");
    console.log(this.user.timezone)
  },
  methods: {
    ...mapActions({
      getUserInfo: 'user/getInfo'
    }),
    async getOptions() {
      const { data } = await userResource.countryOptions();
      this.countries = data;
      this.timezones = moment.tz.names();
    },
    async submit() {
      const { data } = await userResource.updateSelf(this.user)
      const actionTitle = 'Update profile'
      if (data.code === 0) {
        this.messageNotify(
          actionTitle,
          this.errorCodeMessage[data.code]['message'],
          'success'
        )
        this.user.password = ''
        this.user.confirmPassword = ''
        // Update user info in state
        this.getUserInfo();
      } else {
        this.messageNotify(
          actionTitle,
          data.errors,
          'error'
        )
        return false
      }
    },
    checkCapslock({ shiftKey, key } = {}) {
      if (key && key.length === 1) {
        if (shiftKey && (key >= 'a' && key <= 'z') || !shiftKey && (key >= 'A' && key <= 'Z')) {
          this.capsTooltip = true
        } else {
          this.capsTooltip = false
        }
      }
      if (key === 'CapsLock' && this.capsTooltip === true) {
        this.capsTooltip = false
      }
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    messageNotify(title, message, type) {
      this.$notify({
        title: title,
        dangerouslyUseHTMLString: true,
        message: `<div>${message}</div>`,
        type: type
      })
    }
  }
}
</script>
